import { render, staticRenderFns } from "./CustomerTypeEditor.vue?vue&type=template&id=04df604d&scoped=true"
import script from "./CustomerTypeEditor.vue?vue&type=script&lang=js"
export * from "./CustomerTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df604d",
  null
  
)

export default component.exports